(function () {
  /* The Written Hug: "set up your year".

     WHY THIS EXISTS, and it is the commercial point of the whole scheduling
     build. A single $15 card cannot pay back at any realistic cost per click
     (see twh-google-search-test-2026-08). A three-card order can, because the
     $0.30 per-ORDER payment fee is charged once and the buyer only has to be
     acquired once. The problem with a bundle is that nobody wakes up wanting
     three greeting cards. Scheduling gives them the reason: the occasions they
     already know are coming, handled in one sitting so they stop forgetting.

     This deliberately does NOT try to be a product picker inside the cart. It
     sends the shopper back into the catalogue with twh_year=1, which
     twh-schedule.js reads to open the date choice for them. Honest, cheap, and
     it cannot break the cart. */

  if (!/\/cart(\/|$|\?)/.test(location.pathname + location.search) && location.pathname !== '/cart') return;

  var OCCASIONS = [
    { label: 'Birthday', handle: 'birthday-cards' },
    { label: 'Anniversary', handle: 'anniversary-cards' },
    { label: 'Thank You', handle: 'thank-you-cards' },
    { label: 'Thinking of You', handle: 'thinking-of-you-cards' },
    { label: 'Congratulations', handle: 'congratulations-cards' },
    { label: 'Just Because', handle: 'just-because-cards' }
  ];

  var ADDON_TYPE_HINT = 'digital-card-video';

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  /* Only worth showing to somebody who already has a card in the cart. A cart
     holding nothing but the video add-on is not a candidate. */
  function cardLines(cart) {
    return (cart.items || []).filter(function (it) {
      return (it.handle || '') !== ADDON_TYPE_HINT;
    });
  }

  function alreadyScheduled(cart) {
    return cardLines(cart).some(function (it) {
      var p = it.properties || {};
      return !!(p['Arrive by'] || p['Mail when'] === 'On a date');
    });
  }

  function build(cart) {
    var cards = cardLines(cart);
    if (!cards.length) return;
    if (document.querySelector('.twh-year')) return;

    var scheduled = alreadyScheduled(cart);

    var box = document.createElement('section');
    box.className = 'twh-year';
    box.setAttribute('aria-label', 'Set up the rest of your year');

    var head = scheduled
      ? 'Good. What else is coming up?'
      : 'While you are here, what else is coming up this year?';
    var sub = scheduled
      ? 'Add the next one now and we will hold it and mail it in time, same as this one. One order, one delivery each on the right day.'
      : 'Birthdays, anniversaries, the ones you always mean to send and then remember three days late. Pick the date now and we hold the card until it is time.';

    var chips = OCCASIONS.map(function (o) {
      return '<a class="twh-year-chip" href="/collections/' + o.handle + '?twh_year=1">' + o.label + '</a>';
    }).join('');

    box.innerHTML =
      '<h2 class="twh-year-h">' + head + '</h2>' +
      '<p class="twh-year-p">' + sub + '</p>' +
      '<div class="twh-year-chips">' + chips + '</div>' +
      '<p class="twh-year-note">Nothing mails until the date you choose, and you can change or cancel any of them until we send it to print.</p>';

    /* Placed directly ABOVE whatever the theme uses to check out, because the
       last thing between the shopper and the checkout button is the only place
       a nudge like this gets read. Each fallback declares its own side rather
       than sharing one rule, since "after the line items" and "before the
       checkout button" are opposite instructions and getting it wrong buries
       the prompt below the fold. */
    var ctas = document.querySelector('.cart__ctas');
    var btn = document.querySelector('[name="checkout"]');
    var items = document.querySelector('cart-items');
    var form = document.querySelector('form[action*="/cart"]');
    var main = document.querySelector('main');

    var target = null, mode = 'before';
    if (ctas) { target = ctas; mode = 'before'; }
    else if (btn) { target = btn.closest('div, form') || btn; mode = 'before'; }
    else if (items) { target = items; mode = 'after'; }
    else if (form) { target = form; mode = 'after'; }
    else if (main) { target = main; mode = 'append'; }
    if (!target || (mode !== 'append' && !target.parentNode)) return;

    if (mode === 'append') target.appendChild(box);
    else if (mode === 'after') target.parentNode.insertBefore(box, target.nextSibling);
    else target.parentNode.insertBefore(box, target);
  }

  function run() {
    getCart().then(build).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* The cart re-renders itself on quantity changes and line removals, which
     wipes anything injected. Re-run after any cart mutation settles. Guarded by
     the already-present check in build() so this can never double-insert. */
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
      var p = of.apply(this, arguments);
      if (/\/cart\/(change|update|add)/.test(url)) {
        p.then(function () {
          setTimeout(function () {
            if (!document.querySelector('.twh-year')) run();
          }, 500);
        }).catch(function () {});
      }
      return p;
    };
  }
})();
